import { withDevtools, withDevToolsStub } from '@angular-architects/ngrx-toolkit';

import { DebugUtilsService } from './debug-utils.service';

export const withDebugDevTools = DebugUtilsService.getIsOta() ? withDevtools : withDevToolsStub;
